var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',{staticStyle:{"display":"inline"},attrs:{"variant":_vm.$props.variant,"text":_vm.$props.text,"icon":"calendar-check"},on:{"click":function($event){return _vm.createMeeting()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }